module.exports = __webpack_public_path__ + "img/caja-cuzco.fb13bcce.svg";